export default {
  apiUrl: process.env.REACT_APP_CIRS_API_URL,
  picturesUrl: process.env.REACT_APP_CIRS_PICTURES_URL
};
